import {permission} from '@/api-services'
import {paginationHandler, parseLinkHeader} from '@/utils/common'
import {errorHandler, successHandler} from '@/utils/handler'
import {toast} from '@/utils/toast'
import {defineStore} from 'pinia'

export const usePermissionStore = defineStore('permissionStore', {
  state: () => ({
    allPermissions: [],
    permissionDetail: {},
    actions: [],
    models: [],
    loading: false,
    error: null,
    permissionsList: [],
    permissionsListLink: {},
    permissionsListLoading: false,
  }),
  getters: {
    getAllPermissionsWithSerialNumber() {
      return this.allPermissions.map((val, index) => ({
        ...val,
        serialNumber: index + 1,
      }))
    },
  },
  actions: {
    async getAllPermissions() {
        this.loading = true
        try {
        const response = await permission.getPermissions()
        const data = response.data
        this.allPermissions = data
        this.permissionsList = data
        this.permissionsListLink = parseLinkHeader(response.headers.link)
      } catch (error) {
        error.map((e) => {
          const errorMsg = errorHandler(e)
          this.error = errorMsg
          toast.error(errorMsg)
        })
      } finally {
        this.loading = false
      }
    },

    async getPermissionById(id) {
        this.loading = true
        try {
        const response = await permission.getPermissionById(id)
        const data = response.data
        this.permissionDetail = data
      } catch (error) {
        error.map((e) => {
          const errorMsg = errorHandler(e)
          this.error = errorMsg
          toast.error(errorMsg)
        })
      } finally {
        this.loading = false
      }
    },

    async getActions() {
        this.loading = true
        try {
        const response = await permission.getActions()
        const data = response.data
        this.actions = data
      } catch (error) {
        error.map((e) => {
          const errorMsg = errorHandler(e)
          this.error = errorMsg
          toast.error(errorMsg)
        })
      } finally {
        this.loading = false
      }
    },

    async getModels() {
        this.loading = true
        try {
        const response = await permission.getModels()
        const data = response.data
        this.models = data
      } catch (error) {
        error.map((e) => {
          const errorMsg = errorHandler(e)
          this.error = errorMsg
          toast.error(errorMsg)
        })
      } finally {
        this.loading = false
      }
    },

    async postPermissions(payload) {
        this.loading = true
        try {
        const response = await permission.postPermissions(payload)
        if (response.status===201) {
          const data = response.data
          this.permissionDetail = data
          toast.success(successHandler('CREATE_PERMISSION_SUCCESS'))
        } else {
          const errorMsg = errorHandler('STH_WENT_WRONG')
          this.error = errorMsg
          toast.error(errorMsg)
        }
      } catch (error) {
        const errorMsg = errorHandler(error)
        this.error = errorMsg
        toast.error(errorMsg)
      } finally {
        this.loading = false
      }
    },

    async deletePermission(id) {
        this.loading = true
        try {
        const response = await permission.deletePermission(id)
        if (response.status===200) {
          toast.success(successHandler('DELETE_PERMISSION_SUCCESS'))
        } else {
          const errorMsg = errorHandler('STH_WENT_WRONG')
          this.error = errorMsg
          toast.error(errorMsg)
        }
      } catch (error) {
        const errorMsg = errorHandler(error)
        this.error = errorMsg
        toast.error(errorMsg)
      } finally {
        this.loading = false
      }
    },
    // TODO (Saroj Dahal): Need to extract this to reusable function.
    async getTablePagination(page, type=null) {
      if (type) {
        this[`${type}Loading`] = true
      } else {
        this.loading = true
      }
      let response = []
      try {
        if (page === 'next') {
          response = await paginationHandler(this[`${type}Link`].next)
        } else if (page === 'prev') {
          response = await paginationHandler(this[`${type}Link`].prev)
        }
        this[type] = response.data
        if (type) {
          this[`${type}Link`] = parseLinkHeader(response.headers.link)
        } else {
          this.link = parseLinkHeader(response.headers.link)
        }
      } catch (error) {
        const errorMsg = errorHandler(error)
        this.error = errorMsg
        toast.error(errorMsg)
      } finally {
        if (type) {
          this[`${type}Loading`] = false
        } else {
          this.loading = false
        }
      }
    },

    async getNextPage(data) {
      const {value} = data
      try {
        const response = await paginationHandler(this.permissionsListLink.next)
        this.allPermissions = [...value, ...response.data]
        this.permissionsListLink = parseLinkHeader(response.headers.link)
      } catch (error) {
        error.map((e) => {
          const errorMsg = errorHandler(e)
          this.error = errorMsg
          toast.error(errorMsg)
        })
      }
    },
  },
})
